<template>
  <base-page
    :title="'Fixture Library'"
  >
    <template #actionButton>
    </template>
    <template #main>
      <v-row dense>
        <v-col cols="12">
          <v-card
            color="grey darken-1"
            dark
          >
            <v-card-title class="text-h5">
              Fixture Assets
            </v-card-title>

            <v-card-subtitle>DCMS Hub library of fixture assest to be used and priced in models.</v-card-subtitle>

            <v-card-actions>
              <v-btn text :to="{ name: 'fixture-viewer', params: {cat: 'fixture_assets'}}">
                View Library
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
                <v-col cols="12">
          <v-card
            color="grey darken-1"
            dark
          >
            <v-card-title class="text-h5">
              Production Assets
            </v-card-title>

            <v-card-subtitle>DCMS Hub library of production assest to be used and priced in models.</v-card-subtitle>

            <v-card-actions>
              <v-btn text>
                View Library
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card
            color="grey darken-1"
            dark
          >
            <v-card-title class="text-h5">
              Refrigeration Assets
            </v-card-title>

            <v-card-subtitle>DCMS Hub library of refrigeration assest to be used and priced in models.</v-card-subtitle>

            <v-card-actions>
              <v-btn text>
                View Library
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
                <v-col cols="12">
          <v-card
            color="grey darken-1"
            dark
          >
            <v-card-title class="text-h5">
              Construction Assets
            </v-card-title>

            <v-card-subtitle>DCMS Hub library of construction assest to be used and priced in models.</v-card-subtitle>

            <v-card-actions>
              <v-btn text>
                View Library
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>

        
      </v-row>
    </template>
  </base-page>
</template>
<script>
  import BasePage from "../BasePage"
  import ModelTable from "@/views/Models/ModelTable"

  export default {
    components: {
      ModelTable,
      BasePage,
    },
    created() {
      this.getBucketList()
    },
  }
</script>
